import React, { type FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

type Props = {
    path: string;
    withQuery: boolean;
};

export const AppNavigate: FC<Props> = ({ path, withQuery }) => {
    const location = useLocation();

    return <Navigate replace to={{ pathname: path, search: withQuery ? location.search : '' }} />;
};
